import { Box, Tab, Tabs } from "@mui/material";

import { NotificationFilterLabel } from "./NotificationFilterLabel";
import { NotificationFilter } from "./types";

import type { NotificationFilterSelectorProps } from "./types";

const TAB_HEIGHT_PIXELS = 46;

export function NotificationFilterTabs(props: NotificationFilterSelectorProps) {
  const { filter, onFilterChange, counts } = props;

  return (
    <Box sx={{ width: "100%", borderBottom: 1, borderColor: "divider" }}>
      <Tabs
        value={filter}
        variant="fullWidth"
        onChange={(_event, value: NotificationFilter) => onFilterChange(value)}
        aria-label="Notification filter"
        sx={{ minHeight: TAB_HEIGHT_PIXELS }}
      >
        {Object.values(NotificationFilter).map((option) => {
          const isActive = option === filter;
          return (
            <Tab
              key={option}
              value={option}
              label={
                <NotificationFilterLabel
                  option={option}
                  count={counts[option]}
                  isActive={isActive}
                />
              }
              sx={{
                minHeight: TAB_HEIGHT_PIXELS,
                fontSize: "13px",
                fontWeight: 500,
                textTransform: "none",
              }}
            />
          );
        })}
      </Tabs>
    </Box>
  );
}
